import { Injectable } from '@angular/core';
import * as moment from "moment";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HttpClient} from "@angular/common/http";
import {OktaAuthService} from "@okta/okta-angular";
// @ts-ignore
import routeRoles from "../../assets/routeRoles.json";

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  userType: string;
  routeRoles: any = routeRoles;
  userRoles: any[] = [];
  accessPaths: string[]= [];
  constructor(public snackBar: MatSnackBar) {

  }

  successMessage(message, position: any = {x: 'end', y: 'bottom'}){
    this.snackBar.open(message, 'close', {
      horizontalPosition: position.x,
      verticalPosition: position.y,
      panelClass: ['success-box'],
      duration: 3000
    })
  }

  errorMessage(message, position: any = {x: 'end', y: 'bottom'}){
    this.snackBar.open(message, 'close', {
      horizontalPosition: position.x,
      verticalPosition: position.y,
      panelClass: ['error-box']
    })
  }

  getStartDateList(startMonth) {
    const startOfMonth = moment().clone().startOf('month');

    const months = [];

    for (let i = startMonth; i <= 25; i++) {
      let nextMont = startOfMonth.clone().add(i, 'M')
      months.push({
        code: nextMont.format('YYYY-MM-DD'),
        code1: nextMont.format('MM/DD/YYYY'),
        text: nextMont.format('MMMM YY')
      })


    }
    return months;

  }

  convertToUploadFileFormat(files){
    const formData: FormData = new FormData();
    if(files.length){
      files.forEach((item, ind) => {
        // const formData: FormData = new FormData();
        if(!item.uploaded)
          formData.append(`file`, item, item.name) ;
        // return formData;
      })
    }
    return formData;
    // const formData: FormData = new FormData();
    // formData.append(`file`, files);
    // return formData;
  }

  formatPhoneNumber(value) {
    // if input value is falsy eg if the user deletes the input, then just return
    if (!value) return value;

    // clean the input for any non-digit values.
    const phoneNumber = value.replace(/[^\d]/g, "");

    // phoneNumberLength is used to know when to apply our formatting for the phone number
    const phoneNumberLength = phoneNumber.length;

    // we need to return the value with no formatting if its less then four digits
    // this is to avoid weird behavior that occurs if you  format the area code to early
    if (phoneNumberLength < 4) return phoneNumber;

    // if phoneNumberLength is greater than 4 and less the 7 we start to return
    // the formatted number
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }

    // finally, if the phoneNumberLength is greater then seven, we add the last
    // bit of formatting and return it.
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 9)}`;
  }

  jsonPath(path, json){
    if(path && path.indexOf('$.') >= 0 &&json) {
      let parsePath = path.slice(2);
      parsePath = parsePath.split('.');
      let val = JSON.parse((JSON.stringify(json)));
      parsePath.forEach(item => {
        if(item.indexOf('[') >= 0){
          val = val[item.slice(0, item.indexOf('['))][parseInt(item.slice(item.indexOf('[') + 1, item.indexOf(']')))]
        }else{
          val = val[item];
        }
      })
      return val;
    }
    return undefined;
  }
  getRandomColor(): string {
    let letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  isQuoteExpired(date){
    let yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(18,0,0);
    let quoteTime = new Date(date).getTime();
    return quoteTime < yesterday.getTime();
  }

  setUserType(userType){
    this.userType = userType;
  }
  getUserType(){
    return this.userType;
  }

  checkRoleAccess(menuItem){
    // return this.routeRoles && Object.keys(this.routeRoles).includes(this.userType) && this.routeRoles[this.userType].includes(menuItem.link.slice(1))
    return this.accessPaths.includes(menuItem.link.slice(1));
  }

  setUserRoles(roles: any[]){
    this.userRoles = roles;
  }
  setAccessPaths(paths: string[]){
    this.accessPaths = paths;
  }
}
